import React from 'react';
import classNames from 'classnames';

import If from '../If/If';
import './FullPageLoader.scss';
import errorImage from '../../../assets/images/error-warning-exclamation.svg';
import { isQCD } from 'src/utils/transactions-util';

interface ErrorPageProps {
  errorMsg: string;
  hasError: boolean;
  heading: string;
  hints?: string;
  retryMsg: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  errorMsg,
  hasError = true,
  heading,
  retryMsg,
  hints,
}) => (
  <div
    className={classNames('full-page-loader-loading-screen', {
      'full-page-loader-error': !hasError,
    })}
    style={{ position: isQCD() ? 'relative' : 'absolute' }}
  >
    <div className="full-page-loader-error-container" id="errorContainer">
      <div className="full-page-loader-icon">
        <img alt="Error" src={errorImage} />
      </div>
      <h2 className="error-page-title">{heading}</h2>

      {errorMsg && <div className="error-page-text-points">{errorMsg}</div>}

      {hints && <div className="error-page-text-points">{hints}</div>}

      <If test={!!retryMsg}>
        <div className="error-page-footer">
          <div className="error-page-return-dashboad-Button">
            {' '}
            <span className={'error'}>{retryMsg}</span>
          </div>
        </div>
      </If>
    </div>
  </div>
);

export default ErrorPage;
